import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, withKeys as _withKeys, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "fieldWrapper field" }
const _hoisted_2 = { style: {"display":"flex"} }
const _hoisted_3 = {
  key: 0,
  class: "label"
}
const _hoisted_4 = {
  key: 0,
  class: "mb-2"
}
const _hoisted_5 = { class: "control" }
const _hoisted_6 = ["type", "value", "maxlength", "disabled", "placeholder", "autocomplete"]

import { trimString } from "@/core/utils";
import { onMounted, ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'FormTextField',
  props: {
    modelValue: null,
    label: null,
    description: null,
    placeholder: null,
    isPassword: { type: Boolean },
    trimmed: { type: Boolean },
    numeric: { type: Boolean },
    length: null,
    validator: null,
    validationId: null,
    isDisabled: { type: Boolean },
    autoFocus: { type: Boolean },
    noAutoFill: { type: Boolean }
  },
  emits: ['update:modelValue', 'enter'],
  setup(__props: any, { emit }) {

const props = __props as {
  modelValue?: string|number,
  label?: string,
  description?: string,
  placeholder?: string,
  
  isPassword?: boolean,

  trimmed?: boolean,
  numeric?: boolean,
  length?: number,

  validator?: (fieldId: any, val: any) => boolean,
  validationId?: string,

  isDisabled?: boolean,
  autoFocus?: boolean,
  noAutoFill?: boolean,
}



// The input element where the form field's value will be bound
const inputElem = ref<any>(null);

// Event for two-way binding


const onInput = (isBlur: boolean) => {
  let val: string = inputElem.value.value;
  if (isBlur && props.trimmed) { val = trimString(val); }
  if (props.numeric) { val = val.replaceAll(/[^0-9\\.]/g, ''); }
  inputElem.value.value = val;

  emit('update:modelValue', val);
};

onMounted(() => {
  if (props.autoFocus) {
    inputElem.value.focus();
  }

  if (props.trimmed && trimString(props.modelValue) != props.modelValue) {
    emit('update:modelValue', trimString(inputElem.value.value));
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (__props.label)
        ? (_openBlock(), _createElementBlock("label", _hoisted_3, _toDisplayString(__props.label), 1))
        : _createCommentVNode("", true),
      _renderSlot(_ctx.$slots, "top")
    ]),
    (__props.description)
      ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(__props.description), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("input", {
        ref_key: "inputElem",
        ref: inputElem,
        class: _normalizeClass(["input", { 'is-danger': __props.validator ? !__props.validator(__props.validationId ? __props.validationId : this, __props.modelValue) : false }]),
        type: __props.isPassword ? 'password' : 'text',
        value: __props.modelValue,
        maxlength: __props.length,
        onInput: _cache[0] || (_cache[0] = ($event: any) => (onInput(false))),
        onBlur: _cache[1] || (_cache[1] = ($event: any) => (onInput(true))),
        onKeyup: _cache[2] || (_cache[2] = _withKeys(($event: any) => (emit('enter')), ["enter"])),
        disabled: __props.isDisabled,
        placeholder: __props.placeholder,
        autocomplete: __props.noAutoFill ? 'new-password': ''
      }, null, 42, _hoisted_6),
      _renderSlot(_ctx.$slots, "default")
    ])
  ]))
}
}

})